module.exports = __webpack_public_path__ + "media/images/lb/933-acd433243a14bb620ee34a1791cd65be.svg";